import {Icon, IconName} from '@wandb/weave/components/Icon';
import React from 'react';

export const RoleIcon: React.FC<{name: IconName}> = ({name}) => (
  <Icon className="h-32 w-32 flex-shrink-0 text-moon-500" name={name} />
);

export const RoleName: React.FC<{children: React.ReactNode}> = ({children}) => (
  <div className="font-semibold">{children}</div>
);

export const RoleDescription: React.FC<{
  children: React.ReactNode;
}> = ({children}) => <div className="text-sm text-moon-500">{children}</div>;

export const RoleItem: React.FC<{children: React.ReactNode}> = ({children}) => {
  return <div className="flex items-center gap-16 py-8">{children}</div>;
};
